import type {
  NavigationMenuStoryblok,
  NewsletterConfigStoryblok,
} from '~/types/storyblok'

export const useConfigStore = defineStore('config', () => {
  const { storyblokVersion } = useStoryblokHelpers()
  const navigationMenu: Ref<NavigationMenuStoryblok | undefined> = ref()
  const subscriptionConfig: Ref<NewsletterConfigStoryblok | undefined> = ref()

  async function fetchConfig(): Promise<void> {
    if (navigationMenu.value) {
      return
    }

    try {
      const { data } = await useStoryblokHelpers().fetchAsyncData<
        NavigationMenuStoryblok | NewsletterConfigStoryblok
      >('stories', {
        starts_with: 'globals/',
        resolve_links: 'story',
        version: storyblokVersion.value,
      })
      navigationMenu.value = data.value.data.stories.find(
        (story) => story.content.component === 'NavigationMenu',
      )?.content as NavigationMenuStoryblok
      subscriptionConfig.value = data.value.data.stories.find(
        (story) => story.content.component === 'NewsletterConfig',
      )?.content as NewsletterConfigStoryblok
    } catch (error) {
      console.error(error)
      throw createError({
        statusCode: 500,
        statusMessage: 'Error fetching config',
      })
    }
  }

  return {
    fetchConfig,
    navigationMenu,
    subscriptionConfig,
  }
})
